export var MemberPaymentCardWalletViewActionType;
(function (MemberPaymentCardWalletViewActionType) {
    MemberPaymentCardWalletViewActionType["RemoveButtonClicked"] = "RemoveButtonClicked";
    MemberPaymentCardWalletViewActionType["MakePrimaryButtonClicked"] = "MakePrimaryButtonClicked";
    MemberPaymentCardWalletViewActionType["CloseModal"] = "CloseModal";
    MemberPaymentCardWalletViewActionType["RemoveCallStarted"] = "RemoveCallStarted";
    MemberPaymentCardWalletViewActionType["MakePrimaryCallStarted"] = "MakePrimaryCallStarted";
    MemberPaymentCardWalletViewActionType["CallFinished"] = "CallFinished";
    MemberPaymentCardWalletViewActionType["UpdateIsAddingCard"] = "UpdateIsAddingCard";
})(MemberPaymentCardWalletViewActionType || (MemberPaymentCardWalletViewActionType = {}));
